import { zodResolver } from '@hookform/resolvers/zod';
import { Button } from '@optools/components/ui/button';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@optools/components/ui/form';
import { Input } from '@optools/components/ui/input';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

const formSchema = z.object({
  streamAccountId: z.string().min(1, { error: 'Stream Account ID is required' }),
  streamName: z.string().min(1, { error: 'Stream name is required' }),
  subscriberToken: z.string().optional(),
});

export type DolbyMillicastSourceFormType = z.infer<typeof formSchema>;

export interface DolbyMillicastSourceFormProps {
  onSubmit: (values: DolbyMillicastSourceFormType) => void;
}

export function DolbyMillicastSourceForm({ onSubmit }: DolbyMillicastSourceFormProps) {
  const form = useForm<DolbyMillicastSourceFormType>({
    defaultValues: {
      streamAccountId: '',
      streamName: '',
      subscriberToken: '',
    },
    resolver: zodResolver(formSchema),
  });

  return (
    <Form {...form}>
      <form
        className="grid min-w-0 grid-cols-[minmax(5rem,1fr)_minmax(5rem,1fr)_minmax(5rem,1fr)_auto] gap-x-4 gap-y-2"
        onSubmit={form.handleSubmit(onSubmit)}>
        <FormField
          control={form.control}
          name="streamName"
          render={({ field }) => (
            <FormItem className="contents">
              <FormLabel className="col-start-1 row-start-1">Stream Name</FormLabel>
              <FormControl className="col-start-1 row-start-2 w-full self-end">
                <Input {...field} />
              </FormControl>
              <FormMessage className="col-start-1 row-start-3" />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="streamAccountId"
          render={({ field }) => (
            <FormItem className="col-start-2 contents">
              <FormLabel className="col-start-2 row-start-1">Stream Account ID</FormLabel>
              <FormControl className="col-start-2 row-start-2 w-full self-end">
                <Input {...field} />
              </FormControl>
              <FormMessage className="col-start-2 row-start-3" />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="subscriberToken"
          render={({ field }) => (
            <FormItem className="contents">
              <FormLabel className="col-start-3 row-start-1">Subscriber Token (Optional)</FormLabel>
              <FormControl className="col-start-3 row-start-2 w-full self-end">
                <Input {...field} />
              </FormControl>
              <FormMessage className="col-start-3 row-start-3" />
            </FormItem>
          )}
        />
        <Button className="col-start-4 row-start-2 self-end" type="submit">
          Submit
        </Button>
      </form>
    </Form>
  );
}
